import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft, Phone } from 'lucide-react';

const History = () => {
  const navigate = useNavigate();

  // Imagens da galeria da história da empresa
  const images = [
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/ctxtn2wh_thumbs001.jpg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/m81r4ncs_thumbs002.jpg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/msma1bn8_thumbs003.jpg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/n0ssqh73_thumbs004.jpg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/6yvr8ma7_thumbs005.jpg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/t4a46y5l_1.jpeg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/v5iyvtva_2.jpeg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/dmxtgq6p_3.jpeg',
    'https://customer-assets.emergentagent.com/job_knorr-auction-1/artifacts/nu5lbx8m_4.jpeg'
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gray-50 text-gray-900 py-8 border-b-4 border-[rgb(25,42,86)]">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between">
            <Button
              onClick={() => navigate('/')}
              variant="ghost"
              className="text-[rgb(25,42,86)] hover:bg-[rgb(25,42,86)] hover:text-white mb-4 font-bold"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Voltar
            </Button>
            
            <a 
              href="https://wa.me/5511999999999" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors font-bold"
            >
              <Phone className="h-4 w-4" />
              WhatsApp
            </a>
          </div>
          
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-black mb-2 text-[rgb(25,42,86)]">HISTÓRIA</h1>
            <p className="text-lg opacity-80 font-semibold">Nossa trajetória de sucesso</p>
          </div>
        </div>
      </div>

      {/* Conteúdo principal */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* Título principal */}
        <div className="text-center mb-12">
          <h2 
            className="text-3xl md:text-4xl font-black text-[rgb(25,42,86)] leading-tight mb-6"
            style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontWeight: 400,
              lineHeight: '100%'
            }}
          >
            Em março de 1960, com a denominação Escritório Rural Jarbas Knorr, 
            iniciamos nossas atividades no município de Jaguarão.
          </h2>
        </div>

        {/* Texto principal */}
        <div className="mb-12">
          <p 
            className="text-lg text-[rgb(25,42,86)] text-justify leading-relaxed font-semibold"
            style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontWeight: 400,
              lineHeight: '120%'
            }}
          >
            Vinte anos após e estabelecidos em Pelotas, já com a denominação Knorr Remates, expandimos nossa área de atuação, além do RS passamos a atuar também no PR e, a partir dos anos 2000 atuamos também em SC.
            <br /><br />
            Somos uma empresa pioneira em diversos aspectos, como na implantação de informática na parte funcional dos leilões e na realização de leilões de elite no RS. Escrevemos uma história fundamentada na tradição, mas com olhos atentos ao futuro.
            <br /><br />
            E hoje, depois de mais de sessenta e cinco anos, seguimos com seriedade e trabalho como nossos compromissos, e nosso objetivo maior é seguir contribuindo positivamente com a evolução do agronegócio brasileiro.
          </p>
        </div>

        {/* Galeria de fotos */}
        <div className="mb-12">
          <h3 className="text-2xl font-black text-[rgb(25,42,86)] text-center mb-8">
            Nossa Trajetória em Imagens
          </h3>
          
          {/* Scroll horizontal para as imagens */}
          <div className="overflow-x-auto pb-4">
            <div className="flex space-x-6" style={{ minWidth: 'max-content' }}>
              {images.map((image, index) => (
                <div key={index} className="flex-shrink-0 bg-white rounded-lg shadow-lg p-2">
                  <img
                    src={image}
                    alt={`História Knorr Leilões ${index + 1}`}
                    className="w-80 h-52 object-contain rounded-lg hover:shadow-xl transition-shadow duration-300"
                    onError={(e) => {
                      e.target.src = `https://via.placeholder.com/300x200/2e3092/white?text=Imagem+${index + 1}`;
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
          
          <div className="text-center mt-4">
            <p className="text-sm text-gray-600">
              Role horizontalmente para ver mais imagens da nossa história
            </p>
          </div>
        </div>

        {/* Seção de marcos importantes */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:border-[rgb(25,42,86)] transition-colors duration-200">
            <div className="text-center">
              <div className="text-3xl font-bold text-[rgb(238,29,37)] mb-2">1960</div>
              <h4 className="text-lg font-black text-[rgb(25,42,86)] mb-2">Fundação</h4>
              <p className="text-gray-600 text-sm">
                Início das atividades.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:border-[rgb(25,42,86)] transition-colors duration-200">
            <div className="text-center">
              <div className="text-3xl font-bold text-[rgb(238,29,37)] mb-2">1980</div>
              <h4 className="text-lg font-black text-[rgb(25,42,86)] mb-2">Expansão</h4>
              <p className="text-gray-600 text-sm">
                Estabelecidos em Pelotas como Knorr Remates atuando em todo RS e também no PR.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:border-[rgb(25,42,86)] transition-colors duration-200">
            <div className="text-center">
              <div className="text-3xl font-bold text-[rgb(238,29,37)] mb-2">2000</div>
              <h4 className="text-lg font-black text-[rgb(25,42,86)] mb-2">Pioneirismo</h4>
              <p className="text-gray-600 text-sm">
                Pioneirismo em informática e atuação também em SC.
              </p>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="text-center bg-white p-8 rounded-lg shadow-md border border-gray-200">
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Nossa história é sua garantia de seriedade, tradição e compromisso com o agronegócio brasileiro.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => navigate('/')}
              className="bg-[rgb(46,48,146)] hover:bg-[rgb(46,48,146)]/90 text-white px-8 py-3"
            >
              Nossos Leilões
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/login')}
              className="border-[rgb(46,48,146)] text-[rgb(46,48,146)] hover:bg-[rgb(46,48,146)] hover:text-white px-8 py-3"
            >
              Fazer Login
            </Button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[rgb(25,42,86)] text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white p-2 rounded">
              <img
                src="https://customer-assets.emergentagent.com/job_knorr-auction-proxy/artifacts/ud6gmi7h_Screenshot_7-removebg-preview.png"
                alt="Knorr Leilões"
                className="h-12 w-auto"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          </div>
          <h3 className="text-2xl font-black mb-2">KNORR LEILÕES</h3>
          <p className="text-gray-300 mb-2">
            tradição, modernidade e eficiência
          </p>
          <p className="text-sm text-gray-400">
            © 2025 Knorr Leilões. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default History;